import { createContext } from "react";
const TextAncestorContext = createContext(false);
var TextAncestorContext_default = TextAncestorContext;
export {
  TextAncestorContext,
  TextAncestorContext_default as default
};
//# sourceMappingURL=TextAncestorContext.js.map
